/* eslint-disable */
import PageScrollHandler from '@js/utils/intersection-observer';
(function() {
  var $ = require('jquery');
  var Handlebars = require('handlebars');
  require('./custom-handlebars-helpers');
  require('history.js');

  if ($('#ProductsTemplate').length === 0) {
    return;
  }

  var showOnlyFeatured = $('#ProductsList .showOnlyFeatured input[type="hidden"]').val();
  var selectedProducts = $('#ProductsList .selectedProducts input[type="hidden"]').val();
  var currentDocID = $('#ProductsList .docID input[type="hidden"]').val();
  var $itemCont = $('#ProductsList .replaced');
  var $loadMore = $('#ProductsList #LoadMore');
  var $clearList = true;
  var skip = 0; //Number of skipped row
  var take = 12; //
  var source = $('#ProductsTemplate').html();
  var template = Handlebars.compile(source);
  var searchTerm = $('#tbProductFilter').val();

  $('#ProductsList .orig').hide();

  window.onpopstate = function(e) {
    getProducts();
    $clearList = true;
  };

  // initial product loading
  getProducts();

  $('#btnProductFilter').click(function() {
    searchTerm = $('#tbProductFilter').val();
    load(0, take, true, searchTerm);
  });

  function timer(time) {
    return new Promise(res => setTimeout(res, time));
  }

  function setBrowserUrl(url, title, query) {
    if (title === '' || title === undefined) {
      title = document.title;
    }
    History.pushState(url + query, title, url + query);
  }

  function load(Skip, Take, ClearList, SearchTerm) {
    SearchTerm = typeof SearchTerm !== 'undefined' ? SearchTerm : '';

    $('#divPostsLoader').html('<img src="/sitefiles/images/loaded-icon.gif">');
    if (ClearList) {
      $itemCont.empty();
    }

    var productCategoryId = 0;

    WebService.LoadProducts(Skip, Take, currentDocID, showOnlyFeatured, SearchTerm, productCategoryId, selectedProducts, function(
      result,
    ) {
      $itemCont.append(template(result.Data));
      animateArticles();
      const thisImg = document.querySelectorAll('.replaced .js-lazy-img');
      if (thisImg !== null && thisImg.length > 0) {
        Array.forEach(thisImg, element => {
          PageScrollHandler.registerImageElement(element);
        });
      }
      if (result.Data.AllLoaded === true) {
        $loadMore.hide();
      } else {
        $loadMore.show();
      }
    });

    $('#divPostsLoader').empty();
    skip += Take;
  }

  function animateArticles() {
    var lis = [];

    $('.replaced .featured-product').each(function() {
      if ($(this).css('opacity') === '0') {
        lis.push(this);
      }
    });

    var delay = 0;
    $(lis).each(function() {
      $(this)
        .delay(delay)
        .animate(
          {
            opacity: 1,
          },
          1000,
        );
      delay += 100;
    });
  }

  function getParameterByName(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  async function getProducts() {
    var pageNum = getParameterByName('page');

    if (pageNum.length === 0) {
      pageNum = 1;
    }

    if (!$clearList) {
      skip = (parseInt(pageNum) - 1) * take;

      load(skip, take, false);
    } else {
      //on page load, if page number is greater than 1, load products for every previous page number as well, SD-1999
      for (var i = 1; i <= parseInt(pageNum); i++) {
        skip = (i - 1) * take;

        await timer(1000);
        load(skip, take, i === 1);
      }
    }
  }

  /* Controls */
  $loadMore.click(function() {
    $clearList = false;
    if (skip > 0) {
      var query = '?page=' + Math.ceil((skip + take) / take);
      setBrowserUrl(window.location.href.split('?')[0], window.document.title, query);
    }
    return false;
  });
})();
